module.exports = "https://cdn.littlereply.com/tt/resource/loading@3x.f7c4dfc6e230dcb0a2c6b1f67e1aed82.png";